jQuery('.goto').click(function(e){
    e.preventDefault();
    gsap.to(window, {duration: 0.5, scrollTo:$(this).attr('href')});
});